import { useState } from "react";
import classnames from "classnames";
import { getBeUrl, randomStringSync } from "~/helpers/utilHelper";
import { UncontrolledTooltip } from "reactstrap";
import { addAccessToken } from "../../helpers/tokenHelper";

type TUserAvatarProps = {
  id: number;
  image?: string;
  initials: string;
  size: string;
  className?: string;
  icon?: string;
  tooltip?: string;
}

const UserAvatar = ({ id, image, initials, size, className, icon, tooltip }: TUserAvatarProps) => {

  const [isImageError, setIsImageError] = useState(false);

  const imageUrl = getBeUrl(addAccessToken(`user/${id}/${image}`));

  const canShowImage = () => !!id && !!image && !isImageError;

  const uid = randomStringSync(2);

  return <div className={classnames("user-avatar", `user-avatar-${size}`, className)} id={"usravt" + uid}>
    {canShowImage() && <img src={imageUrl} className="user-avatar-img" onError={() => setIsImageError(true)} />}
    {!canShowImage() && <div className="user-avatar-noimg bg-primary bg-soft text-primary">
      {initials && <span className="user-avatar-initials">{initials}</span>}
      {!initials && <i className={classnames("user-avatar-icon", { [icon ?? '']: !!icon, "fas fa-user": !icon })}></i>}
    </div>}
    {!!tooltip && <UncontrolledTooltip placement="top" target={"usravt" + uid}>{tooltip}</UncontrolledTooltip>}
  </div>
}

export default UserAvatar;